import { createRouter, createWebHashHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'nav',
    component: () => import(/* webpackChunkName: "nav" */ '@/nav/navLeft.vue'),
    redirect: '/person',
    children: [
      {
        path: '/person',
        name: 'person',
        meta: { title: '快解析-用户中心' },
        component: () => import(/* webpackChunkName: "person" */ '@/views/person/personIndex.vue'),
      },
      {
        path: '/orderForm',
        name: 'orderForm',
        meta: { title: '快解析-我的订单' },
        component: () => import(/* webpackChunkName: "orderForm" */ '@/views/orderForm/orderForm.vue'),
      },
      {
        path: '/coupon',
        name: 'coupon',
        meta: { title: '快解析-我的优惠劵' },
        component: () => import(/* webpackChunkName: "coupon" */ '@/views/coupon/couponIndex.vue'),
      },
      {
        path: '/activity',
        name: 'activity',
        meta: { title: '快解析-活动详情' },
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/activityIndex.vue'),
      },
      {
        path: '/addressManagement',
        name: 'addressManagement',
        meta: { title: '快解析-地址管理' },
        component: () => import(/* webpackChunkName: "addressManagement" */ '@/views/addressManagement/addressManagement.vue'),
      }
    ],
    
  },
  {
        path: '/activityHome',
        name: 'activityHome',
        meta: { title: '快解析-推广活动' },
        component: () => import(/* webpackChunkName: "activityHome" */ '@/views/activity/activityHome.vue'),
  },
  {
        path: '/confirmOrder',
        name: 'confirmOrder',
        meta: { title: '快解析-确认订单' },
        component: () => import(/* webpackChunkName: "confirmOrder" */ '@/views/confirmOrder/confirmOrder.vue'),
  },
  {
        path: '/addAddress',
        name: 'addAddress',
        meta: { title: '快解析-新增收件地址' },
        component: () => import('@/components/AddAddress/AddAddress.vue'),
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history:createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  if (to.path === '/activityHome') {
    if (window._hmt) {
         window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
     }
   }
  next()
})
export default router
